import { createApp } from "@vue/runtime-dom";
import { Component } from 'vue';
import { RouteRecordRaw } from "vue-router";
import { Store } from "vuex";
import { createWidgetRouter } from "./routerUtils";
import { i18nwidget } from '../config/i18n'
import vueDebounce from 'vue-debounce'

import VueDOMPurifyHTML from 'vue-dompurify-html';

export interface WidgetConfig {
  name: string;
  widget: Component;
  routes?: RouteRecordRaw[];
  store?: Store<unknown>;
  i18n?: boolean
  debounce?: boolean
}

export function createWidget(config: WidgetConfig): void {
  document.querySelectorAll(`[data-vue-widget-${config.name}]`).forEach(element => {
    const widget = createApp(config.widget, { ...(element as any).dataset })
    if (config.routes) {
      widget.use(createWidgetRouter(config.routes))
    }
    if (config.store) {
      widget.use(config.store)
    }
    if (config.i18n) {
      widget.use(i18nwidget)
    }
    if (config.debounce) {
      widget.use(vueDebounce)
    }
    widget.use(VueDOMPurifyHTML);
    widget.mount(element);
  })
}

export function createWidgets(configs: WidgetConfig[]): void {
  configs.forEach(config => createWidget(config))
}
